<template>
  <div>
    <div class="md-layout">
      <period-selector
        title="Parâmetros de Seleção de Dados"
        sub-title="Selecione as opções de busca de dados (período máximo 1 ano)"
        :default-start="DEFAULT_START"
        :default-end="DEFAULT_END"
        :max-duration="MAX_DURATION"
        @onClickFetch="loadManagementReportsData"
        @dataChanged="intervalChanged"
      />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Incidentes com Downtime
            </h4>
            <p class="category">
              Meta: 0 incidentes
            </p>
          </md-card-header>
          <loading :loading="!downtimeChartData">
            <bar-chart
              :chart-data="downtimeChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Corretivas Emergenciais (%)
            </h4>
            <p class="category">
              Meta: ≤ {{ EMEGENCY_CORRECTIVE_GOAL }}%
            </p>
          </md-card-header>
          <loading :loading="!emergencyCorrectiveChartData">
            <bar-chart
              :chart-data="emergencyCorrectiveChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Corretivas Programadas (%)
            </h4>
            <p class="category">
              Meta: ≤ {{ PROGRAMMED_CORRECTIVE_GOAL }}%
            </p>
          </md-card-header>
          <loading :loading="!programmedCorrectiveChartData">
            <bar-chart
              :chart-data="programmedCorrectiveChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Chamados por Modalidade
            </h4>
            <p
              class="category csv-link"
              @click="downloadManagementTicketsCsv()"
            >
              Exportar todos os chamados
            </p>
          </md-card-header>
          <loading :loading="!ticketsByModalityChartData">
            <bar-chart
              :chart-data="ticketsByModalityChartData"
              :show-legend="showChartsLegend"
              :stacked="true"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              1º atendimento dentro do prazo (%)
            </h4>
            <p class="category">
              Meta: ≥ {{ TIME_ON_SERVICE_GOAL }}%
            </p>
          </md-card-header>
          <loading :loading="!onTimeServiceChartData">
            <bar-chart
              :chart-data="onTimeServiceChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Solução definitiva dentro do prazo (%)
            </h4>
            <p class="category">
              Meta: ≥ {{ SOLUTION_IN_TIME_GOAL }}%
            </p>
          </md-card-header>
          <loading :loading="!onTimeSolvedChartData">
            <bar-chart
              :chart-data="onTimeSolvedChartData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Chamados de 1º atendimento fora do prazo
            </h4>
          </md-card-header>
          <loading :loading="!didNotServiceChartData">
            <bar-chart
              :show-legend="showChartsLegend"
              :chart-data="didNotServiceChartData"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Chamados solucionados fora do prazo
            </h4>
          </md-card-header>
          <loading :loading="!didNotSolveChartData">
            <bar-chart
              :show-legend="showChartsLegend"
              :chart-data="didNotSolveChartData"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        v-if="showNoTicketForMonthWarning"
        class="no-tickets-message md-layout-item md-size-100"
      >
        * Não há chamados no mês
      </div>

      <md-divider class="md-layout-item md-size-100 divider" />
      <md-subheader class="md-layout-item md-size-100 sub-header">
        Pendências
      </md-subheader>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: purple">
            <slot name="header">
              <md-icon>add_alert</md-icon>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">
                Total
              </p>
              <h3 class="title">
                {{ totalPending }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: red">
            <slot name="header">
              <md-icon>warning</md-icon>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">
                Corretivas Emergenciais
              </p>
              <h3 class="title">
                {{ totalEmergencyCorrectivePending }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: green">
            <slot name="header">
              <router-link to="/finance">
                <md-icon>calendar_today</md-icon>
              </router-link>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">
                Corretivas Programadas
              </p>
              <h3 class="title">
                {{ totalProgCorrectivePending }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <md-card class="md-card-stats">
          <md-card-header style="background-color: blue">
            <slot name="header">
              <md-icon>phonelink</md-icon>
            </slot>
          </md-card-header>
          <md-card-content>
            <slot name="content">
              <p class="category">
                Total de Clientes Online
              </p>
              <h3 class="title">
                {{ totalOnlineSites }}
              </h3>
            </slot>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <slot name="footer" />
          </md-card-actions>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Por Gerência
            </h4>
          </md-card-header>
          <loading :loading="!pendenciesByManagementsData">
            <bar-chart
              :chart-data="pendenciesByManagementsData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Por UF
            </h4>
          </md-card-header>
          <loading :loading="!pendenciesByStatesData">
            <bar-chart
              :chart-data="pendenciesByStatesData"
              :show-legend="showChartsLegend"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Por Modalidade
            </h4>
          </md-card-header>
          <loading :loading="!pendenciesByModalitiesData">
            <bar-chart
              :chart-data="pendenciesByModalitiesData"
              :show-legend="showChartsLegend"
              :stacked="true"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Categorizadas
            </h4>
          </md-card-header>
          <loading :loading="!pendenciesByCategoriesData">
            <bar-chart
              :chart-data="pendenciesByCategoriesData"
              :show-legend="showChartsLegend"
              :stacked="true"
              :show-labels="true"
            />
          </loading>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Chamados
            </h4>
          </md-card-header>
          <md-card-content>
            <loading :loading="!ticketExportListShow">
              <md-table
                v-model="oldestPendingTickets"
                table-header-color="gray"
              >
                <md-table-empty-state
                  md-label="Nenhuma pendência encontrada..."
                />

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                >
                  <md-table-cell md-label="Gerência">
                    {{ item.management }}
                  </md-table-cell>
                  <md-table-cell md-label="UF">
                    {{ item.uf }}
                  </md-table-cell>
                  <md-table-cell md-label="Cliente">
                    {{ item.client }}
                  </md-table-cell>
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Tempo Pend">
                    {{ item.pendingTime }} dias
                  </md-table-cell>
                  <md-table-cell md-label="Motivo da Pend">
                    {{ item.pendencyReason }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    <a
                      class="fa fa-edit"
                      :href="'/openticket/' + item.id"
                    >{{ item.id }}</a>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <md-card-actions
                v-if="oldestPendingTickets && oldestPendingTickets.length"
                layout="row"
                layout-align="end center"
              >
                <md-button
                  v-if="ticketExportListShow === true"
                  @click="downloadPendingTicketsCsv()"
                >
                  EXPORT
                </md-button>
                <i
                  v-if="ticketExportListShow === false"
                  class="fa fa-spinner"
                />
              </md-card-actions>
            </loading>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <options-button>
      <options-button-item @click="showChartsLegend = !showChartsLegend">
        {{ showChartsLegend ? "Desabilitar legendas" : "Habilitar legendas" }}
      </options-button-item>

      <options-button-item @click="downloadReportCharts()">
        Baixar gráficos
      </options-button-item>
    </options-button>
  </div>
</template>

<script>
import { DateTime, Duration } from "luxon";

import Loading from "../components/Loading";
import BarChart from "../components/BarChart.vue";
import OptionsButton from "../components/OptionsButton";
import PeriodSelector from "../components/PeriodSelector";
import OptionsButtonItem from "../components/OptionsButtonItem";

import { chartColorThreshold } from "../util/chart-color-threshold";
import { MAP_MODALITY_COLORS } from "../util/map-modality-colors";
import { uniquePropArray } from "../util/unique-prop-array";
import { generateLookupMap } from "../util/generate-lookup-map";
import { DateTimeFormats } from "../util/datetime.formats";

import {
  getOldestPendenciesList,
  getOnlineUsers,
  getPendenciesByCategories,
  getPendenciesByManagements,
  getPendenciesByModalities,
  getPendenciesByStates,
  getPendenciesCsv,
  getPendenciesKpi,
} from "../_services/pendencies.service";
import {
  getDidNotServiceByMonth,
  getDidNotSolveByMonth,
  getEmergencyCorrectiveTicketsByMonth,
  getManagementReportsTicketsCsv,
  getOnTimeServiceByMonth,
  getOnTimeSolvedByMonth,
  getProgrammedCorrectiveTicketsByMonth, getReportCharts,
  getTicketsByModalityByMonth,
  getTicketsDowntime,
} from "../_services/management-reports.service";
import { EventBus, events } from "../_helpers/event-bus";
import { parseTime } from "../util/parse-time";
import { fillMonths } from "../util/fill-months";

const MAP_CATEGORIES_COLORS = new Map([
  [ "aguardando assinatura do cliente", "#3366cc" ],
  [ "motivo não informado", "#dc3912" ],
  [ "aguardando material", "#66aa00" ],
  [ "aguardando agendamento do cliente", "#ff9900" ],
  [ "aguardando prestador de servico", "#994499" ],
  [ "aguardando equipe de suporte técnico", "#22aa99" ],
]);

export default {
  components: {
    OptionsButton,
    OptionsButtonItem,
    BarChart,
    Loading,
    PeriodSelector,
  },
  data() {
    const MAX_DURATION = Duration.fromObject({ years: 1 });

    return {
      totalPending: 0,
      totalEmergencyCorrectivePending: 0,
      totalProgCorrectivePending: 0,
      totalOnlineSites: 0,

      showChartsLegend: true,

      ticketExportListShow: false,
      oldestPendingTickets: [],

      pendenciesByManagementsData: null,
      pendenciesByCategoriesData: null,
      pendenciesByStatesData: null,
      pendenciesByModalitiesData: null,
      downtimeChartData: null,
      emergencyCorrectiveChartData: null,
      programmedCorrectiveChartData: null,
      ticketsByModalityChartData: null,
      onTimeServiceChartData: null,
      onTimeSolvedChartData: null,
      didNotServiceChartData: null,
      didNotSolveChartData: null,

      showNoTicketForMonthWarning: false,

      DEFAULT_START: DateTime
        .now()
        .minus(MAX_DURATION)
        .startOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),

      DEFAULT_END: DateTime
        .now()
        .endOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),

      MAX_DURATION,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.calculateShowLegend);
    });
  },
  async created() {
    this.EMEGENCY_CORRECTIVE_GOAL = 8;
    this.PROGRAMMED_CORRECTIVE_GOAL = 3.69;
    this.TIME_ON_SERVICE_GOAL = 95;
    this.SOLUTION_IN_TIME_GOAL = 93;

    this.calculateShowLegend();

    this.filter = {
      start: this.DEFAULT_START,
      end: this.DEFAULT_END,
    };

    await Promise.allSettled([
      this.loadPendingData(),
      this.loadManagementReportsData(),
    ]);

    EventBus.$on(events.CHANGED_ENTITY, this.onChangeEntity);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateShowLegend);
    EventBus.$off(events.CHANGED_ENTITY, this.onChangeEntity);
  },
  methods: {
    calculateShowLegend() {
      this.showChartsLegend = window.innerWidth >= 1800;
    },
    onChangeEntity() {
      return Promise.allSettled([
        this.loadPendingData(),
        this.loadManagementReportsData(),
      ]);
    },
    intervalChanged(filter) {
      this.filter = filter;
    },
    async loadManagementReportsData() {
      this.resetManagementReportsData();

      await Promise.allSettled([
        this.loadManagementReportsDowntime(this.filter),
        this.loadManagementReportsEmergencyCorrectives(this.filter),
        this.loadManagementReportsProgrammedCorrectives(this.filter),
        this.loadManagementReportsTicketByModality(this.filter),
        this.loadManagementReportsOnTimeService(this.filter),
        this.loadManagementReportsOnTimeSolved(this.filter),
        this.loadManagementReportsDidNotService(this.filter),
        this.loadManagementReportsDidNotSolve(this.filter),
      ]);
    },
    resetPendingData() {
      this.oldestPendingTickets = [];
      this.pendenciesByManagementsData = null;
      this.pendenciesByCategoriesData = null;
      this.pendenciesByStatesData = null;
      this.pendenciesByModalitiesData = null;
    },
    resetManagementReportsData() {
      this.downtimeChartData = null;
      this.emergencyCorrectiveChartData = null;
      this.programmedCorrectiveChartData = null;
      this.ticketsByModalityChartData = null;
      this.onTimeServiceChartData = null;
      this.onTimeSolvedChartData = null;
      this.didNotServiceChartData = null;
      this.didNotSolveChartData = null;

      this.showNoTicketForMonthWarning = false;
    },
    async loadPendingData() {
      this.resetPendingData();

      this.totalOnlineSites = await getOnlineUsers();

      const { total, emergencyFix, scheduledFix } = await getPendenciesKpi();

      this.totalPending = total || 0;
      this.totalEmergencyCorrectivePending = emergencyFix || 0;
      this.totalProgCorrectivePending = scheduledFix || 0;

      await Promise.allSettled([
        this.loadPendenciesByManagements(),
        this.loadPendenciesByCategories(),
        this.loadPendenciesByModality(),
        this.loadPendenciesByState(),
        this.loadOldestTickets(),
      ]);
    },
    async downloadPendingTicketsCsv() {
      const file = await getPendenciesCsv();
      const fileURL = URL.createObjectURL(new Blob([ file ]));

      const anchor = document.createElement("a");
      anchor.setAttribute("href", fileURL);
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("download", "export.csv");
      anchor.click();
    },
    async downloadManagementTicketsCsv() {
      const file = await getManagementReportsTicketsCsv(this.filter);

      const fileURL = URL.createObjectURL(new Blob([ file ]));

      const anchor = document.createElement("a");
      anchor.setAttribute("href", fileURL);
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("download", "export.csv");
      anchor.click();
    },

    async downloadReportCharts() {
      this.$progress.start();

      const { file, filename } = await getReportCharts(this.filter);

      const fileURL = URL.createObjectURL(new Blob([ file ]));

      const anchor = document.createElement("a");
      anchor.setAttribute("href", fileURL);
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("download", filename);
      anchor.click();

      this.$progress.stop();
    },

    // Separate load pendencies
    async loadPendenciesByManagements() {
      // By Management
      const pendenciesByManagementsResponse = await getPendenciesByManagements();
      const managements = pendenciesByManagementsResponse.map(({ management }) => management);

      this.pendenciesByManagementsData = {
        labels: managements,
        datasets: [
          {
            label: "Chamados",
            data: pendenciesByManagementsResponse.map(({ totalPending }) => totalPending),
            backgroundColor: "#3366CC",
          },
        ],
      };
    },
    async loadPendenciesByCategories() {
      // By Categories
      const response = await getPendenciesByCategories();
      const categories = uniquePropArray(response, "category");
      const managements = uniquePropArray(response, "management");
      const lookup = generateLookupMap(response, [ "category", "management" ], "totalPending");

      this.pendenciesByCategoriesData = {
        labels: managements,
        datasets: categories.map((category) => ({
          label: category,
          data: managements.map((management) => lookup[category][management] || 0),
          backgroundColor:
            MAP_CATEGORIES_COLORS.get(category.toLowerCase()) || "#3366CC",
        })),
      };
    },
    async loadPendenciesByModality() {
      // By Modalities
      const response = await getPendenciesByModalities();
      const modalities = uniquePropArray(response, "modality");
      const managements = uniquePropArray(response, "management");
      const lookup = generateLookupMap(response, [ "modality", "management" ], "totalPending");

      this.pendenciesByModalitiesData = {
        labels: managements,
        datasets: modalities.map((modality) => ({
          label: modality,
          data: managements.map((management) => lookup[modality][management] || 0),
          backgroundColor:
            MAP_MODALITY_COLORS.get(modality.toLowerCase()) || "#3366CC",
        })),
      };
    },
    async loadPendenciesByState() {
      // By States
      const pendenciesByStatesResponse = await getPendenciesByStates();
      const ufLabels = pendenciesByStatesResponse.map(({ uf }) => uf);
      this.pendenciesByStatesData = {
        labels: ufLabels,
        datasets: [
          {
            label: "Chamados",
            data: pendenciesByStatesResponse.map(
              ({ totalPending }) => totalPending,
            ),
            backgroundColor: "#3366CC",
          },
        ],
      };
    },
    async loadOldestTickets() {
      this.oldestPendingTickets = await getOldestPendenciesList();
      this.ticketExportListShow = true;
    },

    // Separate load management reports
    async loadManagementReportsDowntime(filter) {
      const response = await getTicketsDowntime(filter);
      const times = this.getFilledMonthsFromFilter(filter);

      const lookup = generateLookupMap(response, [ "time" ], "incidentsWithDowntime");

      this.downtimeChartData = {
        labels: times.map(parseTime),
        datasets:
          (response &&
            response.length && [
              {
                label: "Chamados",
                data: times.map(time => lookup[time] || 0),
                backgroundColor: "#3366CC",
              },
            ]) ||
          [],
      };
    },
    async loadManagementReportsEmergencyCorrectives(filter) {
      const response = await getEmergencyCorrectiveTicketsByMonth(filter);
      const times = this.getFilledMonthsFromFilter(filter);

      const lookup = generateLookupMap(response, [ "time" ], "correctivesPercent");

      this.emergencyCorrectiveChartData = {
        labels: times.map(this.parseTimeLabel(lookup)),
        datasets:
          (response &&
            response.length && [
              {
                label: "Percentual",
                data: times.map(time => (lookup[time] || 0).toFixed(2)),
                backgroundColor: chartColorThreshold(
                  this.EMEGENCY_CORRECTIVE_GOAL,
                  "#DC3912",
                  "#3366CC",
                ),
              },
            ]) ||
          [],
      };
    },
    async loadManagementReportsProgrammedCorrectives(filter) {
      const response = await getProgrammedCorrectiveTicketsByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);

      const lookup = generateLookupMap(response, [ "time" ], "correctivesPercent");

      this.programmedCorrectiveChartData = {
        labels: times.map(this.parseTimeLabel(lookup)),
        datasets:
          (response &&
            response.length && [
              {
                label: "Percentual",
                data: times.map(time => (lookup[time] || 0).toFixed(2)),
                backgroundColor: chartColorThreshold(
                  this.PROGRAMMED_CORRECTIVE_GOAL,
                  "#DC3912",
                  "#3366CC",
                ),
              },
            ]) ||
          [],
      };
    },
    async loadManagementReportsTicketByModality(filter) {
      const response = await getTicketsByModalityByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);
      const modalities = uniquePropArray(response, "modality");

      const lookup = generateLookupMap(response, [ "time", "modality" ], "count");

      this.ticketsByModalityChartData = {
        labels: times.map(parseTime),
        datasets: modalities.map(modality => ({
          label: modality,
          data: times.map(time => (lookup[time] || {})[modality] || 0),
          backgroundColor: MAP_MODALITY_COLORS.get(modality.toLowerCase()) || "#3366CC",
        })),
      };
    },
    async loadManagementReportsOnTimeService(filter) {
      const response = await getOnTimeServiceByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);
      const lookup = generateLookupMap(response, [ "time" ], "timeOnServicePercent");

      this.onTimeServiceChartData = {
        labels: times.map(this.parseTimeLabel(lookup)),
        datasets:
          (response &&
            response.length && [
              {
                label: "Percentual",
                data: times.map(time => (lookup[time] || 0).toFixed(2)),
                backgroundColor: chartColorThreshold(
                  this.TIME_ON_SERVICE_GOAL,
                  "#3366CC",
                  "#DC3912",
                ),
              },
            ]) ||
          [],
      };
    },
    async loadManagementReportsOnTimeSolved(filter) {
      const response = await getOnTimeSolvedByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);
      const lookup = generateLookupMap(response, [ "time" ], "solvedOnTimePercent");

      this.onTimeSolvedChartData = {
        labels: times.map(this.parseTimeLabel(lookup)),
        datasets: response &&
          response.length && ([
            {
              name: "Percentual",
              data: times.map(time => (lookup[time] || 0).toFixed(2)),
              backgroundColor: chartColorThreshold(
                this.SOLUTION_IN_TIME_GOAL,
                "#3366CC",
                "#DC3912",
              ),
            },
          ]) || [],
      };
    },
    async loadManagementReportsDidNotService(filter) {
      const response = await getDidNotServiceByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);
      const lookup = generateLookupMap(response, [ "time" ], "count");

      this.didNotServiceChartData = {
        labels: times.map(parseTime),
        datasets:
          (response &&
            response.length && [
              {
                label: "Chamados",
                data: times.map(time => lookup[time] || 0),
                backgroundColor: "#3366CC",
              },
            ]) ||
          [],
      };
    },
    async loadManagementReportsDidNotSolve(filter) {
      const response = await getDidNotSolveByMonth(filter);

      const times = this.getFilledMonthsFromFilter(filter);
      const lookup = generateLookupMap(response, [ "time" ], "count");

      this.didNotSolveChartData = {
        labels: times.map(parseTime),
        datasets:
          (response &&
            response.length && [
              {
                label: "Chamados",
                data: times.map(time => lookup[time] || 0),
                backgroundColor: "#3366CC",
              },
            ]) ||
          [],
      };
    },
    getFilledMonthsFromFilter(filter) {
      return fillMonths(
        DateTime.fromFormat(filter.start, DateTimeFormats.HTML_INPUT_DATETIME),
        DateTime.fromFormat(filter.end, DateTimeFormats.HTML_INPUT_DATETIME),
      ).map(v => v.toFormat("MM/yyyy"));
    },
    parseTimeLabel(lookup) {
      if (Object.keys(lookup).length === 0) {
        return time => time;
      }

      return (time) => {
        let parsedTime = parseTime(time);
        if (lookup[time] === undefined) {
          parsedTime += "*";
          this.showNoTicketForMonthWarning = true;
        }
        return parsedTime;
      };
    }
  },
};
</script>

<style>
.sub-header {
  font-size: 1.125rem;
  margin-bottom: 1rem;
}

.divider {
  margin: 1rem 0;
}

.csv-link {
  cursor: pointer;
}

.no-tickets-message {
  font-weight: bold;
}
</style>
